"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _GridList = _interopRequireDefault(require("../lists/GridList"));
var _LogoListItem = _interopRequireDefault(require("../lists/LogoListItem"));
var _helpers = require("../../utils/helpers");
var _DeviceAndPlatformListsModule = _interopRequireDefault(require("../../scss/DeviceAndPlatformLists.module.scss"));
function DeviceAndPlatformLists(_ref) {
  let {
    platformResources
  } = _ref;
  let firstColumnTotal = platformResources.size < 4 ? platformResources.size : Math.ceil(platformResources.size / 2);
  const entries = [...platformResources.entries()];
  const keys = [...platformResources.keys()];
  if (keys[0].slug === 'video-platforms') firstColumnTotal = 1;
  const firstColumnEntries = entries.slice(0, firstColumnTotal);
  const secondColumnEntries = entries.slice(firstColumnTotal, platformResources.size);
  return /*#__PURE__*/_react.default.createElement("section", {
    className: (0, _helpers.classes)([_DeviceAndPlatformListsModule.default['devices-platforms'], 'devices-platforms'])
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _helpers.classes)([_DeviceAndPlatformListsModule.default['devices-platforms__column'], 'devices-platforms__column']),
    style: {
      gridColumn: platformResources.size >= 4 ? "1/2" : "1/3"
    }
  }, firstColumnEntries.map(entry => /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _helpers.classes)([_DeviceAndPlatformListsModule.default['devices-platforms__column-item'], 'devices-platforms__column-item']),
    key: "".concat(entry[0].slug)
  }, /*#__PURE__*/_react.default.createElement(_GridList.default, {
    headerText: entry[0].name.toLowerCase()
  }, entry[1].map(item => {
    var _item$target;
    return /*#__PURE__*/_react.default.createElement(_LogoListItem.default, {
      imageSource: item.image_url,
      altText: item.alt_text,
      href: item.link,
      target: (_item$target = item === null || item === void 0 ? void 0 : item.target) !== null && _item$target !== void 0 ? _item$target : '_blank',
      key: "sd-".concat(item.id)
    });
  }))))), platformResources.size >= 4 && /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _helpers.classes)([_DeviceAndPlatformListsModule.default['devices-platforms__column'], 'devices-platforms__column']),
    style: {
      gridColumn: "2/3"
    }
  }, secondColumnEntries.map(entry => /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _helpers.classes)([_DeviceAndPlatformListsModule.default['devices-platforms__column-item'], 'devices-platforms__column-item']),
    key: "".concat(entry[0].slug)
  }, /*#__PURE__*/_react.default.createElement(_GridList.default, {
    headerText: entry[0].name.toLowerCase()
  }, entry[1].map(item => {
    var _item$target2;
    return /*#__PURE__*/_react.default.createElement(_LogoListItem.default, {
      imageSource: item.image_url,
      altText: item.alt_text,
      href: item.link,
      target: (_item$target2 = item === null || item === void 0 ? void 0 : item.target) !== null && _item$target2 !== void 0 ? _item$target2 : '_blank',
      key: "sd-".concat(item.id)
    });
  }))))));
}
var _default = exports.default = DeviceAndPlatformLists;